import DigirepView from "../../../jsx/components/Dashboard/Digirep/DigirepView";

const DigirepWrapper = () => {
  return <DigirepView />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(DigirepWrapper);
